(() => {
  'use strict';

  let globalTotalCartPrice = '';

  function formatCartPrice(cents) {
    const dollars = (Number(cents) / 100).toFixed(2);
    return `$${dollars.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`;
  }

  function calcItemSubtotal(priceCents, quantity) {
    return formatCartPrice(Number(priceCents) * Number(quantity));
  }

  function updateCartCount(callback) {
    fetch('/cart.js')
      .then(r => r.json())
      .then(data => {
        const totalCartPrice = formatCartPrice(data.total_price);
        globalTotalCartPrice = totalCartPrice;

        const cartCountElement = document.getElementById('cartCount');
        if (cartCountElement) {
          cartCountElement.textContent = data.item_count;
          cartCountElement.classList.toggle('hidden-count', data.item_count === 0);
        }

        if (callback) callback(data, totalCartPrice);
      })
      .catch(err => console.error('Error fetching cart:', err));
  }

  function updateCartModal(data, totalCartPrice) {
    const modalContent = document.getElementById('addToCartModalContent');
    if (!modalContent) return console.error('Modal content element not found');

    const priceCents = Number(data.price);

    const content = `
      <div class="cart-summary">
        <div class="cart-items">
          <div class="cart-item">
            <div class="cart-item-image">
              <img src="${data.image}" alt="Product Image" style="width:70px">
            </div>
            <div class="cart-item-details">
              <div class="cart-item-title" style="font-weight:bold;padding:0 1rem;color:#000;">${data.product_title}</div>
              <div class="cart-item-sku" style="padding:0 1rem;">SKU: ${data.sku ?? ''}</div>
            </div>
          </div>
          <div class="cart-item-price">
            <h3>Product Price</h3>
            <p>${formatCartPrice(priceCents)}</p>
          </div>
        </div>
        <div class="cart-details">
          <div class="cart-quantity">
            <p>Quantity</p>
            <div class="quantity-buttons">
              <button id="decrementQty">-</button>
              <span id="cartQty">${data.quantity}</span>
              <button id="incrementQty">+</button>
            </div>
          </div>
          <div class="cart-subtotal">
            <h3>Product Subtotal</h3>
            <p>${calcItemSubtotal(priceCents, data.quantity)}</p>
            <h3>Cart Total</h3>
            <p class="cart-total">${totalCartPrice}</p>
          </div>
          <div class="bottom-buttons">
            <button id="proceedToCheckout" onclick="window.location.href='/cart'"><span class="icon icon-cart"></span>Proceed to Checkout</button>
            <button class="cartModalContinueButton" id="cartModalContinueButton">Continue Shopping</button>
          </div>
        </div>
      </div>
    `;

    modalContent.innerHTML = content;
    attachQuantityButtonListeners(data.id, data.quantity);
    document.getElementById('cartModalContinueButton')?.addEventListener('click', hideCartModal);
    showCartModal();
  }

  function attachQuantityButtonListeners(variantId, initialQty) {
    const dec = document.getElementById('decrementQty');
    const inc = document.getElementById('incrementQty');
    const qtyDisplay = document.getElementById('cartQty');
    if (!dec || !inc || !qtyDisplay) return;

    dec.addEventListener('click', () => {
      if (initialQty > 1) updateCartItemQuantity(variantId, --initialQty, qtyDisplay);
    });
    inc.addEventListener('click', () => {
      updateCartItemQuantity(variantId, ++initialQty, qtyDisplay);
    });
  }

  function updateCartItemQuantity(variantId, newQuantity, qtyDisplay) {
    const payload = JSON.stringify({ id: String(variantId), quantity: newQuantity });

    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: payload
    })
    .then(r => r.ok ? r.json() : r.json().then(e => { throw new Error(JSON.stringify(e)); }))
    .then(data => {
      qtyDisplay.textContent = newQuantity;

      const itemSubtotalEl = document.querySelector('.cart-subtotal p');
      if (itemSubtotalEl) {
        const updatedItem = data.items.find(it => it.id === variantId);
        if (updatedItem) itemSubtotalEl.textContent = calcItemSubtotal(updatedItem.price, updatedItem.quantity);
      }

      const cartTotalEl = document.querySelector('.cart-total');
      if (cartTotalEl) cartTotalEl.textContent = formatCartPrice(data.total_price);

      updateCartCount();
    })
    .catch(err => console.error('Error updating cart item quantity:', err));
  }

  function showCartModal() {
    const modal = document.getElementById('addToCartModal');
    if (!modal) return;
    modal.style.display = 'block';
    modal.classList.remove('hideCart');
    modal.classList.add('show');
  }

  function hideCartModal() {
    const modal = document.getElementById('addToCartModal');
    if (!modal) return;
    modal.classList.add('hideCart');
    modal.addEventListener('animationend', function handleEnd(e) {
      if (e.animationName === 'slideUp') {
        modal.style.display = 'none';
        modal.classList.remove('show', 'hideCart');
      }
    }, { once: true });
  }

  function outsideClickListener(event) {
    const modal = document.getElementById('addToCartModal');
    const content = document.getElementById('addToCartModalContent');
    if (modal && content && modal.style.display === 'block' && !content.contains(event.target)) {
      hideCartModal();
    }
  }

document.addEventListener('DOMContentLoaded', () => {
  updateCartCount();

  // 1) Page type
  const isCollection = document.querySelector('.grid-uniform') !== null;
  const shouldShowModal = !isCollection; // <- no modal on collection

  if (isCollection) {
    // 2) COLLECTION: add without modal
    const buttons = document.querySelectorAll('.product-cart-button');
    buttons.forEach(button => {
      button.addEventListener('click', (event) => {
        event.preventDefault();

        const variantId = button.getAttribute('data-variant-id');
        const fd = new FormData();
        fd.append('id', variantId);
        fd.append('quantity', '1');

        fetch('/cart/add.js', {
          method: 'POST',
          body: fd,
          headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }
        })
        .then(r => r.json())
        .then(() => {
          // Update only the badge/count; no modal
          updateCartCount();

          // Optional: quick visual feedback on the button
          button.disabled = true;
          const old = button.innerHTML;
          button.innerHTML = '<span class="icon icon-cart"></span> Added';
          setTimeout(() => {
            button.disabled = false;
            button.innerHTML = old;
          }, 1500);
        })
        .catch(e => console.error('Error adding product to cart:', e));
      });
    });

  } else {
    // 3) PDP: show modal as usual
    const addToCartButton = document.getElementById('addToCart');
    if (addToCartButton) {
      addToCartButton.addEventListener('click', (event) => {
        event.preventDefault();
        const form = document.getElementById('addToCartForm');
        const fd = new FormData(form);

        fetch('/cart/add.js', {
          method: 'POST',
          body: fd,
          headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }
        })
        .then(r => r.json())
        .then(lineItem => {
          if (shouldShowModal) {
            updateCartCount((_cart, total) => updateCartModal(lineItem, total));
          } else {
            updateCartCount();
          }
        })
        .catch(e => console.error('Error adding product to cart:', e));
      });
    }
  }

  window.addEventListener('click', outsideClickListener);
});
})();